// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__zYJYs","header":"ClearentDisclaimer_header__2gngG","inner":"ClearentDisclaimer_inner__1BMBC"};